import { CTNumFmt } from '../model-pb/ct-num-fmt-sml';
import { TXSHEET2MSO_FORMATCODE_MAPPING } from '../format-code';

function isGeneralCell(numberFormat: CTNumFmt) {
    return !numberFormat || numberFormat.numFmtId === undefined || numberFormat.numFmtId === 0;    // 新的 format 没有或者为常规
}

function isGeneralCell2(numberFormat: CTNumFmt) {
    return !numberFormat || numberFormat.formatCode === 'General';    // 新的 format 没有或者为常规
}

/**
 * 根据给定 formatCode 获得数值格式
 */
function getNumberFormatByFormatCode(formatCode?: string): CTNumFmt {
    // 有可能出现 formatData 不是格式串而是格式类别(text, numeral...)的情况，这里做一下兼容处理
    // 确保一定是数据格式串
    formatCode = TXSHEET2MSO_FORMATCODE_MAPPING[formatCode || 'General'] || formatCode || 'General';
    const numberFormat = new CTNumFmt({ formatCode });
    return numberFormat;
}

export {
    isGeneralCell,
    isGeneralCell2,
    getNumberFormatByFormatCode,
};
